/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Deleted_DescriptionInputs */

const en_compare_event_groups_csv_deleted_description = /** @type {(inputs: Compare_Event_Groups_Csv_Deleted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event exists in Group A but not in Group B`)
};

const fr_compare_event_groups_csv_deleted_description = /** @type {(inputs: Compare_Event_Groups_Csv_Deleted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'événement existe dans le groupe A mais pas dans le groupe B`)
};

const de_compare_event_groups_csv_deleted_description = /** @type {(inputs: Compare_Event_Groups_Csv_Deleted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Ereignis existiert in Gruppe A, aber nicht in Gruppe B.`)
};

const it_compare_event_groups_csv_deleted_description = /** @type {(inputs: Compare_Event_Groups_Csv_Deleted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'evento esiste nel Gruppo A ma non nel Gruppo B`)
};

const ru_compare_event_groups_csv_deleted_description = /** @type {(inputs: Compare_Event_Groups_Csv_Deleted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие существует в группе А, но отсутствует в группе В.`)
};

const es_compare_event_groups_csv_deleted_description = /** @type {(inputs: Compare_Event_Groups_Csv_Deleted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El evento existe en el Grupo A pero no en el Grupo B`)
};

const zh_cn2_compare_event_groups_csv_deleted_description = /** @type {(inputs: Compare_Event_Groups_Csv_Deleted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该事件存在于A组中，但不存在于B组中。`)
};

const ja_compare_event_groups_csv_deleted_description = /** @type {(inputs: Compare_Event_Groups_Csv_Deleted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントはグループ A には存在するがグループ B には存在しない`)
};

const hi_compare_event_groups_csv_deleted_description = /** @type {(inputs: Compare_Event_Groups_Csv_Deleted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह घटना समूह A में मौजूद है लेकिन समूह B में नहीं है।`)
};

const pt_pt2_compare_event_groups_csv_deleted_description = /** @type {(inputs: Compare_Event_Groups_Csv_Deleted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O evento existe no Grupo A, mas não no Grupo B.`)
};

/**
* | output |
* | --- |
* | "Event exists in Group A but not in Group B" |
*
* @param {Compare_Event_Groups_Csv_Deleted_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_deleted_description = /** @type {((inputs?: Compare_Event_Groups_Csv_Deleted_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Deleted_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_csv_deleted_description(inputs)
	if (locale === "de") return de_compare_event_groups_csv_deleted_description(inputs)
	if (locale === "it") return it_compare_event_groups_csv_deleted_description(inputs)
	if (locale === "ru") return ru_compare_event_groups_csv_deleted_description(inputs)
	if (locale === "es") return es_compare_event_groups_csv_deleted_description(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_csv_deleted_description(inputs)
	if (locale === "ja") return ja_compare_event_groups_csv_deleted_description(inputs)
	if (locale === "hi") return hi_compare_event_groups_csv_deleted_description(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_csv_deleted_description(inputs)
	return en_compare_event_groups_csv_deleted_description(inputs)
});